import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApAmountDisplayComponent } from '@ap/amounts';
import { ApButtonComponent, ApSkipLinkComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApHeaderComponent } from '@ap/header';
import { ApIconComponent } from '@ap/icon';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { MijnFeedbackModule } from '@ap/mijn-feedback';
import { MijnZoekenModule } from '@ap/mijn-zoeken';
import { ApPanelComponent } from '@ap/panel';

import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { ConversationalModule } from './conversational/conversational.module';
import { MijnOverzichtTemplateComponent } from './mijn-overzicht-template.component';
import { MijnOverzichtTemplateService } from './mijn-overzicht-template.service';
import { SendableOrdersModalModule } from './sendable-orders-modal/sendable-orders-modal.module';
import { SkeletonModule } from './skeleton/skeleton.module';

/**
 * @name MijnOverzichtTemplateModule
 * @ngdoc module
 */
@NgModule({
    declarations: [MijnOverzichtTemplateComponent],
    providers: [MijnOverzichtTemplateService],
    imports: [
        ApAmountDisplayComponent,
        ApButtonComponent,
        ApContentModule,
        ApHeaderComponent,
        ApIconComponent,
        ApPanelComponent,
        ApSkipLinkComponent,
        BreadcrumbModule,
        CommonModule,
        ConversationalModule,
        MijnFeedbackModule,
        MijnZoekenModule,
        SendableOrdersModalModule,
        SessiebeheerModule,
        SkeletonModule
    ],
    exports: [MijnOverzichtTemplateComponent]
})
export class MijnOverzichtTemplateModule {}
